import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=0e897d77"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"
import style0 from "./navbar.vue?vue&type=style&index=0&id=0e897d77&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e897d77')) {
      api.createRecord('0e897d77', component.options)
    } else {
      api.reload('0e897d77', component.options)
    }
    module.hot.accept("./navbar.vue?vue&type=template&id=0e897d77", function () {
      api.rerender('0e897d77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/navbar.vue"
export default component.exports